import React from 'react';
import axios from "../../containers/api";
import { toCurrency } from "../../helpers/Utils";
import { Table } from "../table/Table";
import { Colxx } from "../common/CustomBootstrap";

class PersonAccountActivities extends React.Component {
  state = {
    Id: this.props?.id,
    role: this.props?.role,
    AllAccountActivity: [],
    lastAccountActivity: [],
  };

  componentDidMount() {
    this.GetAllAccountActivity();
    this.LastAccountActivity();
  }

  GetAllAccountActivity = () => {
    const model = {
      DriverId: this.state.role === "Driver" ? this.state.Id : null,
      TransportationCompanyId: this.state.role === "TransportationCompany" ? this.state.Id : null,
    };

    this.props.showSpinner();
    axios.post('api/v1/account-activities/TransactionsListweb', model)
      .then((res) => {
        this.props.hideSpinner();
        this.setState({ AllAccountActivity: res.data.data || [] });
      })
      .catch((error) => {
        this.props.hideSpinner();
        console.log(error.response);
      });
  };

  LastAccountActivity = () => {
    const model = {
      DriverId: this.state.role === "Driver" ? this.state.Id : null,
      TransportationCompanyId: this.state.role === "TransportationCompany" ? this.state.Id : null,
    };

    this.props.showSpinner();
    axios.post('api/v1/account-activities/TransactionsList', model)
      .then((res) => {
        this.props.hideSpinner();
        this.setState({ lastAccountActivity: res.data.data || [] });
      })
      .catch((error) => {
        this.props.hideSpinner();
        console.log(error.response);
      });
  };

  render() {
    const { AllAccountActivity, lastAccountActivity } = this.state;
    const balance = lastAccountActivity[0] || {};

    return (
      <>
        {/* استایل‌های داخلی */}
        <style jsx>{`
          .account-container {
            font-family: 'Vazir', Tahoma, sans-serif;
            direction: rtl;
            padding: 20px;
            background: #f8f9fa;
            min-height: 100vh;
          }
          .page-header {
            background: linear-gradient(135deg, #4361ee, #3f37c9);
            color: white;
            padding: 1.8rem 2rem;
            border-radius: 16px;
            box-shadow: 0 8px 25px rgba(67, 97, 238, 0.25);
            margin-bottom: 2rem;
            text-align: center;
          }
          .page-title {
            font-size: 1.6rem;
            font-weight: 700;
            margin: 0;
          }
          .balance-cards {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
            gap: 1.5rem;
            margin-bottom: 2rem;
          }
          .balance-card {
            background: white;
            border-radius: 16px;
            padding: 1.5rem;
            box-shadow: 0 8px 25px rgba(0,0,0,0.08);
            text-align: center;
            transition: all 0.3s ease;
          }
          .balance-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 15px 35px rgba(0,0,0,0.12);
          }
          .balance-label {
            font-size: 1rem;
            color: #6c757d;
            margin-bottom: 0.5rem;
            font-weight: 600;
          }
          .balance-value {
            font-size: 2.2rem;
            font-weight: 800;
            color: #4361ee;
          }
          .balance-value.withdrawable {
            color: #2ecc71;
          }

          /* استایل‌دهی به Table */
          :global(.transactions-table-wrapper) {
            border-radius: 14px;
            overflow: hidden;
            box-shadow: 0 10px 30px rgba(0,0,0,0.08);
          }
          :global(.transactions-table-wrapper table) {
            margin: 0;
            border-collapse: separate;
            border-spacing: 0 10px;
          }
          :global(.transactions-table-wrapper th) {
            background: #f1f3f5 !important;
            color: #2d3436 !important;
            font-weight: 700 !important;
            font-size: 0.95rem !important;
            padding: 16px 20px !important;
            text-align: center !important;
            border: none !important;
          }
          :global(.transactions-table-wrapper td) {
            background: white !important;
            padding: 16px 20px !important;
            text-align: center !important;
            border: none !important;
            box-shadow: 0 2px 8px rgba(0,0,0,0.05);
            transition: all 0.2s ease;
          }
          :global(.transactions-table-wrapper tr:hover td) {
            background: #f8f9fa !important;
            transform: scale(1.01);
          }
          :global(.amount-deposit) { color: #2ecc71; font-weight: 600; }
          :global(.amount-withdraw) { color: #e74c3c; font-weight: 600; }
          :global(.ellipsis-desc) {
            max-width: 250px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            cursor: help;
          }
          :global(.ellipsis-desc:hover) {
            white-space: normal;
            overflow: visible;
            word-break: break-word;
            background: #fff;
            z-index: 10;
            position: relative;
            box-shadow: 0 4px 12px rgba(0,0,0,0.1);
            border-radius: 8px;
            padding: 10px;
          }

          @media (max-width: 768px) {
            .page-header { padding: 1.2rem; font-size: 1.3rem; }
            .balance-value { font-size: 1.8rem; }
            :global(.transactions-table-wrapper th),
            :global(.transactions-table-wrapper td) {
              padding: 12px 10px !important;
              font-size: 0.85rem !important;
            }
          }
        `}</style>

        <div className="account-container">
          {/* هدر صفحه */}
          <div className="page-header">
            <h1 className="page-title">فعالیت‌های حساب</h1>
            <p style={{ margin: '8px 0 0', fontSize: '1rem', opacity: 0.9 }}>
              مشاهده تراکنش‌ها و وضعیت موجودی
            </p>
          </div>

          {/* کارت‌های موجودی */}
          <div className="balance-cards">
            <div className="balance-card">
              <div className="balance-label">موجودی کل</div>
              <div className="balance-value">
                {toCurrency(balance.totalBalance || 0)} تومان
              </div>
            </div>
            <div className="balance-card">
              <div className="balance-label">قابل برداشت</div>
              <div className="balance-value withdrawable">
                {toCurrency(balance.availableBalance || 0)} تومان
              </div>
            </div>
          </div>

          {/* جدول تراکنش‌ها */}
          <div className="transactions-table-wrapper">
            <Table
              tableHeaders={[
                "شماره تراکنش",
                "نوع تراکنش",
                "مبلغ",
                "ساعت",
                "تاریخ",
                "موجودی",
                "توضیحات",
              ]}
              tableRow={AllAccountActivity}
              tableData={[
                x => <code style={{ fontSize: '0.85rem' }}>{x.transactionNumber}</code>,
                x => (
                  <span className={`badge badge-${x.accountType === 'واریز' ? 'success' : 'danger'} badge-pill`}>
                    {x.accountType}
                  </span>
                ),
                x => {
                  const amount = x.deposit !== 0 ? x.deposit : x.withdraw;
                  const isDeposit = x.deposit !== 0;
                  return (
                    <span className={isDeposit ? 'amount-deposit' : 'amount-withdraw'}>
                      {isDeposit ? '+' : '-'} {toCurrency(amount)}
                    </span>
                  );
                },
                x => x.transactionTime,
                x => x.transactionDate,
                x => <strong>{toCurrency(x.availableBalance)}</strong>,
                x => (
                  <div className="ellipsis-desc" title={x.description}>
                    {x.description || "—"}
                  </div>
                ),
              ]}
              emptyMessage={
                <div style={{ textAlign: 'center', padding: '40px', color: '#95a5a6' }}>
                  تراکنشی یافت نشد
                </div>
              }
            />
          </div>
        </div>
      </>
    );
  }
}

export default PersonAccountActivities;